import { useEffect, useState } from 'react';
import { isPersistentStorageGranted } from '../services/PersistentStorageService';

/**
 * Hook that checks if we're on iOS and if persistent storage is granted.
 * Used to show warnings to iOS users who don't have persistent storage enabled.
 */
export function useStorageStatus() {
  const [isIOS, setIsIOS] = useState(false);
  const [isPersistent, setIsPersistent] = useState(true);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    async function checkStatus() {
      try {
        // Check if running on iOS
        const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
        setIsIOS(isAppleDevice);

        if (isAppleDevice) {
          // Check persistent storage status
          const persistent = await isPersistentStorageGranted();
          setIsPersistent(persistent);
        }
      } catch (error) {
        console.error('Error checking storage status:', error);
      } finally {
        setIsChecking(false);
      }
    }

    checkStatus();
  }, []);

  return {
    isIOS,
    isPersistent,
    isChecking,
    needsWarning: isIOS && !isPersistent && !isChecking,
  };
}
